import { TableCell, TableRow } from '@/components/ui/table';

export function NoDataTableRow({ numColumns }: { numColumns: number }) {
  return (
    <TableRow>
      <TableCell colSpan={numColumns} className="h-24 text-center">
        No results.
      </TableCell>
    </TableRow>
  );
}
